import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ref, getDownloadURL } from "firebase/storage"; // Firebase Storage functions
import { storage } from "../../utils/firebase"; // Your Firebase config
import "./IntroductionSlider.css";

const IntroductionSlider = () => {
  const navigate = useNavigate();
  const [sliderItems, setSliderItems] = useState([]);

  // Predefined filenames for the slider images
  const imageConfig = [
    { filename: "culture.jpg", title: "Culture", link: "/culture" },
    { filename: "festivals.jpg", title: "Festivals", link: "/festival" },
    { filename: "community.jpg", title: "Community", link: "/community" },
  ];

  // Fetch specific images from Firebase Storage
  useEffect(() => {
    const fetchSliderImages = async () => {
      try {
        const items = await Promise.all(
          imageConfig.map(async ({ filename, title, link }) => {
            const fileRef = ref(storage, `home/${filename}`);
            const url = await getDownloadURL(fileRef);
            return { imgSrc: url, title, link };
          })
        );
        setSliderItems(items);
      } catch (error) {
        console.error("Error fetching slider images:", error);
      }
    };

    fetchSliderImages();
  }, []);

  return (
    <div className="slider-carousel">
      <h2 className="slider-title">Explore about Bacoor</h2>
      <p className="slider-subtitle">
        Welcome to Explore Bacoor, your ultimate guide to discovering the vibrant city of Bacoor, Cavite!
      </p>
      <div className="slider-items">
        {sliderItems.map((item, index) => (
          <div
            key={index}
            className="slider-card"
            onClick={() => navigate(item.link)}
          >
            <img src={item.imgSrc} alt={item.title} className="slider-image" />
            <div className="slider-caption">
              <h3>{item.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IntroductionSlider;
